const playBoard = document.querySelector(".play-board");
const scoreElement = document.querySelector(".score");
const highScoreElement = document.querySelector(".high-score");
const controls = document.querySelectorAll(".controls i");

let gameOver = false;

let foodX, foodY;
let snakeX = 15,
  snakeY = 25;
let snakeBody = [];
let velocityX = 0,
  velocityY = 0;
let setIntervalId;
let score = 0;
let highScore = localStorage.getItem("high-score") || 0;
highScoreElement.innerText = `높은 점수: ${highScore}`;

document.addEventListener("DOMContentLoaded", function () {
  const tutorialDone = localStorage.getItem("snake_tutorial_done");
  const timestamp = localStorage.getItem("snake_tutorial_timestamp");
  if (!tutorialDone || (timestamp && Date.now() - timestamp > 86400000)) {
    localStorage.removeItem("snake_tutorial_done");
    localStorage.removeItem("snake_tutorial_timestamp");
    document.getElementById("gameIntro").style.display = "flex";
  } else {
    startGame();
  }
});

function nextStep(step) {
  let current = document
    .getElementById(`step${step}`)
    .classList.remove("active");
  let next = document.getElementById(`step${step + 1}`).classList.add("active");

  if (!current || !next) return; // Ensure elements exist

  // Fade out the current step
  current.style.opacity = "0";

  setTimeout(() => {
    current.style.display = "none"; // Hide completely after fade out

    next.style.display = "flex"; // Make next step visible before fading in
    next.style.opacity = "1";
  }, 100); // Matches CSS transition time
}

const changeFoodPosition = () => {
  foodX = Math.floor(Math.random() * 30) + 1; // Generate random number between (1-30)
  foodY = Math.floor(Math.random() * 30) + 1;
};

const handleGameOver = () => {
  clearInterval(setIntervalId);

  const finalScore = score;
  document.getElementById("finalScore").innerText = finalScore;
  const title = document.getElementById("gameOverTitle");
  const message = document.getElementById("gameOverMessage");
  const discountSection = document.getElementById("discountSection");
  const discountMessage = document.getElementById("discountMessage");
  const copyBtn = document.getElementById("copyCodeBtn");
  const nextRewardMessage = document.getElementById("nextRewardMessage");

  let discountCode = "";
  let discountText = "";
  let nextTarget = "";

  if (finalScore >= 50) {
    title.innerText = "🏆 당신은 뱀 챔피언입니다!";
    message.innerText = "와! 완전히 부숴버렸어! 넌 전설이야! 🏅";
    discountCode = "SNAKE40";
    discountText =
      "<strong>🔥 대규모 40% 할인을 해제했어요!<br/><br/> 결제 시 붙여넣기만 하면 즉시 할인!</strong>";
  } else if (finalScore >= 30) {
    title.innerText = "🔥 인상적인 점수!";
    message.innerText = "뱀을 다루는 솜씨가 정말 대단했어요! 불이 났어요! 🔥";
    discountCode = "SNAKE20";
    discountText =
      "<strong>💰 20% 할인을 해제했어요!<br/><br/> 결제 시 붙여넣기만 하면 즉시 할인!</strong>";
  } else if (finalScore >= 15) {
    title.innerText = "💰 축하해요!";
    message.innerText = "개선되고 있어요! 더 큰 할인을 계속하세요! 🎯";
    discountCode = "SNAKE10";
    discountText =
      "<strong>🎉 10% 할인코드를 드려요! <br/><br/> 결제 시 붙여넣기만 하면 즉시 할인!</strong>";
  } else {
    title.innerText = "이런! 끝났어요😢";
    message.innerHTML =
      "<strong>하지만 실패는 성공의 어머니! <br/> 다시 도전해서 할인코드를 받아보세요 :)</strong/";
    nextTarget = 15 - finalScore;
  }

  // If the player didn’t reach a discount level, tell them how many points were left
  if (nextTarget > 0) {
    nextRewardMessage.style.display = "block";
    nextRewardMessage.innerText = `성공까지 ${nextTarget}점 남았어요!`;
  } else {
    nextRewardMessage.innerText = ""; // Clear message if they reached a reward
  }

  // If a discount is earned, show the section
  if (discountCode) {
    discountSection.style.display = "flex";
    discountMessage.innerHTML = discountText;
    copyBtn.setAttribute("data-code", discountCode);
    if (copyBtn) {
      copyBtn.innerHTML = `${discountCode} <i class="fa-regular fa-copy"></i>`;
    }
  } else {
    discountSection.style.display = "none";
  }

  document.getElementById("gameOverScreen").style.display = "flex";
};

// Copy discount code function
function copyDiscountCode() {
  const copyBtn = document.getElementById("copyCodeBtn");
  const discountCode = copyBtn.getAttribute("data-code");

  navigator.clipboard.writeText(discountCode).then(() => {
    navigator.clipboard.writeText(discountCode).then(() => {
      copyBtn.innerHTML = '<i class="fa-solid fa-check"></i> Copied!';
    });
  });
}

// Restart function
function restartGame() {
  document.getElementById("gameOverScreen").style.display = "none";
  location.reload();
}

// Return to home function
function goToHome() {
  window.location.href = "/"; // Change to your actual homepage URL
}

const changeDirection = (e) => {
  // Prevent default behavior to stop scrolling
  if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
    e.preventDefault();
  }

  // Change velocity value based on key press
  if (e.key === "ArrowUp" && velocityY != 1) {
    velocityX = 0;
    velocityY = -1;
  } else if (e.key === "ArrowDown" && velocityY != -1) {
    velocityX = 0;
    velocityY = 1;
  } else if (e.key === "ArrowLeft" && velocityX != 1) {
    velocityX = -1;
    velocityY = 0;
  } else if (e.key === "ArrowRight" && velocityX != -1) {
    velocityX = 1;
    velocityY = 0;
  }
};

// Add event listener to capture keydown events
document.addEventListener("keydown", changeDirection);

// Update button click events to simulate key press
controls.forEach((button) =>
  button.addEventListener("click", (event) => {
    changeDirection({ key: button.dataset.key, preventDefault: () => {} });
  })
);

const initGame = () => {
  if (gameOver) return handleGameOver();

  let htmlMarkup = `<div class="food" style="grid-area: ${foodY} / ${foodX}"></div>`;

  if (snakeX == foodX && snakeY == foodY) {
    changeFoodPosition();
    snakeBody.push([foodX, foodY]); // Pushing food position to snake body array
    score++;

    highScore = score >= highScore ? score : highScore; // If score > high score => high score will be equal to current score
    localStorage.setItem("high-score", highScore);
    scoreElement.innerText = `점수: ${score}`;
    highScoreElement.innerText = `높은 점수: ${highScore}`;
  }

  for (let i = snakeBody.length - 1; i > 0; i--) {
    // Shifting forward the values of elements in snake body by one
    snakeBody[i] = snakeBody[i - 1];
  }

  snakeBody[0] = [snakeX, snakeY]; // Add new Snake head

  // Updating the snake's head position based on current velocity
  snakeX += velocityX;
  snakeY += velocityY;
  console.log("Position of snake: ", snakeX, snakeY);

  // Checking if the snake's head is out of wall, if so setting game over to true
  if (snakeX <= 0 || snakeX > 30 || snakeY <= 0 || snakeY > 30) {
    gameOver = true;
    // location.reload(); // Reload the page
  }

  for (let i = 0; i < snakeBody.length; i++) {
    htmlMarkup += `<div class="head" style="grid-area: ${snakeBody[i][1]} / ${snakeBody[i][0]}"></div>`;

    // Check if the snake head hit the body, if so set gameOver to true
    if (
      i !== 0 &&
      snakeBody[0][1] === snakeBody[i][1] &&
      snakeBody[0][0] === snakeBody[i][0]
    ) {
      gameOver = true;
    }
  }

  playBoard.innerHTML = htmlMarkup;
};
function startGame() {
  localStorage.setItem("snake_tutorial_done", true);
  localStorage.setItem("snake_tutorial_timestamp", Date.now()); // Save current time
  document.getElementById("gameIntro").style.display = "none";

  changeFoodPosition();
  setIntervalId = setInterval(initGame, 125);
}
document.addEventListener("keydown", changeDirection);
